import { createContext, useContext } from "react";

export type DocTitleMap = Record<string, string>;

export const DocTitleContext = createContext<DocTitleMap>({});

export function useDocTitle(contentId?: string): string | undefined {
  const map = useContext(DocTitleContext);
  if (!contentId) return undefined;
  return map[contentId];
}
